import React, { useState, useEffect, useRef } from 'react';
import {  Divider, Table, Popconfirm, Card, Tooltip, Switch,Input,Button,Tag,Row, Col, Drawer, Tabs } from 'antd';
import Highlighter from 'react-highlight-words';
import { ColumnProps } from 'antd/lib/table';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import {CheckCircleOutlined,CloseCircleOutlined,RightSquareOutlined,EyeOutlined,EditOutlined,SearchOutlined } from '@ant-design/icons';

import './reprocessing-repacking-grid.css';
import { ForkLiftJobService } from '@gtpl/shared-services/warehouse-management';
import { ForkliftJobcodesDropDownDto } from '@gtpl/shared-models/sale-management';
import { ForkLiftJobRequestDTO } from '@gtpl/shared-models/warehouse-management';

/* eslint-disable-next-line */
export interface ReprocessingRepackingGridProps {}

export function ReprocessingRepackingGrid(
  props: ReprocessingRepackingGridProps
) {

  const [searchText, setSearchText] = useState(''); 
  const [searchedColumn, setSearchedColumn] = useState('');
  const [jobcodesData, setJobcodesData] = useState<any[]>([]);
  const [availableStockData, setAvailableStockData] = useState<any[]>([]);

  const searchInput = useRef(null);
  const [page, setPage] = React.useState(1);
  const columns = useState('');
  const service = new ForkLiftJobService;
  const { TabPane } = Tabs;
  const [pageSize,setPageSize] = useState<number>(null);

  /**
   * used for column filter
   * @param dataIndex column data index
   */
   const getColumnSearchProps = (dataIndex:string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={ searchInput }
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
    record[dataIndex]
    ? record[dataIndex]
       .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) {    setTimeout(() => searchInput.current.select());   }
    },
    render: text =>
      text ?(
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) :text
      )
      : null
     
  });

  /**
   * 
   * @param selectedKeys 
   * @param confirm 
   * @param dataIndex 
   */
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };
  const columnsSkelton: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      responsive: ['sm'],
      render: (text, object, index) => (page-1) * 10 +(index+1)
    },
    {
      title: 'Job Purpose',
      dataIndex: 'jobPurpose',
      // responsive: ['lg'],
      sorter: (a, b) => a.jobPurpose.localeCompare(b.jobPurpose),
      sortDirections: ['descend', 'ascend'],
      // ...getColumnSearchProps('jobPurpose')
      
    },
    {
      title: 'Job Code',
      dataIndex: 'jobCode',
      // responsive: ['lg'],
      sorter: (a, b) => a.jobCode.localeCompare(b.jobCode),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('jobCode')
    },
    {
      title: 'Customer PO',
      dataIndex: 'poNumber',
      // responsive: ['lg'],
      sorter: (a, b) => a.poNumber.localeCompare(b.poNumber),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('poNumber')
    },
    {
      title: 'Product SKU',
      dataIndex: 'variantCode',
      // responsive: ['lg'],
      sorter: (a, b) => a.variantCode.localeCompare(b.variantCode),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('variantCode')
    },
    {
      title: 'Pack Style',
      dataIndex: 'packStyle',
      // responsive: ['lg'],
      sorter: (a, b) => a.packStyle.localeCompare(b.packStyle),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('packStyle')
    },
    {
      title: 'Total Cartons',
      dataIndex: 'totalJobCartons',
      align:'right',
      // responsive: ['lg'],
      render: (status, rowData) => (
        <>
          {rowData.totalJobCartons + "(Qty : "+ rowData.totIssuedQuantity+")"}

        </>
      ),
    },
    {
      title: 'Received Quantity',
      dataIndex: 'totReceivedQuantity',
      align:'right',
      // responsive: ['lg'],
      sorter: (a, b) => a.totReceivedQuantity.localeCompare(b.totReceivedQuantity),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('totReceivedQuantity')
    },
    {
      title: 'Excess Quantity',
      dataIndex: 'excessQuantity',
      align:'right',
      // responsive: ['lg'],
      sorter: (a, b) => a.excessQuantity.localeCompare(b.excessQuantity),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('excessQuantity')
    },
    {
      title: 'Damage Quantity',
      dataIndex: 'damagedCartons',
      align:'right',
      // responsive: ['lg'],
      sorter: (a, b) => a.damagedCartons.localeCompare(b.damagedCartons),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('damagedCartons')
    },
    {
      title: 'Status',
      dataIndex: 'status',
      // responsive: ['lg'],
      sorter: (a, b) => a.status.localeCompare(b.status),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('status')
    },
  ];

  const columnSkelton: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      responsive: ['sm'],
      render: (text, object, index) => (page-1) * 10 +(index+1)
    },
    {
      title: 'SO Number',
      dataIndex: 'saleOrderNo',
      // responsive: ['lg'],
      sorter: (a, b) => a.saleOrderNo.localeCompare(b.saleOrderNo),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('saleOrderNo')
    },
    {
      title: 'Customer PO',
      dataIndex: 'assignablePO',
      // responsive: ['lg'],
      sorter: (a, b) => a.assignablePO.localeCompare(b.assignablePO),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('assignablePO')
    },
    {
      title: 'Product SKU',
      dataIndex: 'assignableItem',
      // responsive: ['lg'],
      sorter: (a, b) => a.assignableItem.localeCompare(b.assignableItem),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('assignableItem')
    },
    {
      title: 'Pack Style',
      dataIndex: 'packStyle',
      // responsive: ['lg'],
      sorter: (a, b) => a.packStyle.localeCompare(b.packStyle),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('packStyle')
    },
    {
      title: 'Net Cases Weight',
      dataIndex: 'caseWeight',
      // responsive: ['lg'],
      sorter: (a, b) => a.caseWeight.localeCompare(b.caseWeight),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('caseWeight')
    },
    {
      title: 'Net Quantity',
      dataIndex: 'netWeight',
      // responsive: ['lg'],
      sorter: (a, b) => a.netWeight.localeCompare(b.netWeight),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('netWeight')
    },
    {
      title: 'Cases',
      dataIndex: 'cases',
      // responsive: ['lg'],
      sorter: (a, b) => a.cases.localeCompare(b.cases),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('cases')
    },
    {
      title: 'Allocated Qty',
      dataIndex: 'cases',
      // responsive: ['lg'],
      sorter: (a, b) => a.cases.localeCompare(b.cases),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('cases')
    },
    {
      title: 'Assigned Qty',
      dataIndex: 'cases',
      // responsive: ['lg'],
      sorter: (a, b) => a.cases.localeCompare(b.cases),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('cases')
    },
    {
      title: 'Need to Allocate',
      dataIndex: 'totalJobCartons',
      align:'right',
      // responsive: ['lg'],
      render: (status, rowData) => (
        <>
          {rowData.totalJobCartons + "(Qty : "+ rowData.totIssuedQuantity+")"}

        </>
      ),
    },
    {
      title: 'Need to Assigned',
      dataIndex: 'totalJobCartons',
      align:'right',
      // responsive: ['lg'],
      render: (status, rowData) => (
        <>
          {rowData.totalJobCartons + "(Qty : "+ rowData.totIssuedQuantity+")"}

        </>
      ),
    },
  ];

  /**
   * 
   * @param pagination 
   * @param filters 
   * @param sorter 
   * @param extra 
   */
  const onChange=(pagination, filters, sorter, extra)=> {
    console.log('params', pagination, filters, sorter, extra);
  }

  useEffect(() => {getForkliftJobCodesForGrid();}, [])
  const getForkliftJobCodesForGrid= () => {
  const plant = Number(localStorage.getItem('unit_id'));
  const req = new ForkLiftJobRequestDTO()
  req.unitId = plant
    service.getForkliftJobCodesForGrid(req).then(res => {
      if (res.status) {
        setJobcodesData(res.data);
        setAvailableStockData(res.data1)
       AlertMessages.getSuccessMessage('Data retreived sucessfully')} else {
        if (res.intlCode) {
          // setJobcodesData([]);
            AlertMessages.getErrorMessage(res.internalMessage);
        } else {
         AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setJobcodesData([]);
    })
  }
  return (
    <Card title={<span style={{color:'white'}}>Repacking</span>}
    style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} >
     <br></br>
     
      {/* <Tabs type={'card'} tabPosition={'top'} onChange={ () =>{setPageSize(10);setPage(1)}} >
        <TabPane
            key="1"
          
            tab={<span style={{ color: "#0ec92d" }}>{'Available Stock: ' + (availableStockData.filter((rec) => rec.rePackQty != null).length)}</span>}
          >      
          <Table
            rowKey={record => record.jobId}
            columns={columnSkelton}
            // expandedRowRender={renderJobItems}
            dataSource={availableStockData.filter((rec) => rec.rePackQty != null)}
            pagination={{
              onChange(current) {
                setPage(current);
              }
            }}
            scroll = {{x:true}}
            onChange={onChange}
            bordered />
        </TabPane>
        <TabPane
          key="2"
        
          tab={<span style={{ color: "#0ec92d" }}>{'Need to do Repack: ' + (jobcodesData.length)}</span>}
        >       */}
        <Row gutter={40}>
          <Col>
              <Card title={'Total Jobs: ' + jobcodesData.length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#bfbfbf'}}></Card>
          </Col>
          <Col>
              <Card title={'Pending Jobs: ' + jobcodesData.filter((rec) => rec.status === "Pending").length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#bfbfbf'}}></Card>
          </Col>
          <Col>
              <Card title={'Completed Jobs: ' + jobcodesData.filter((rec) => rec.status === "Completed").length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#bfbfbf'}}></Card>
          </Col>
        </Row><br></br>
          <Table
            rowKey={record => record.jobId}
            columns={columnsSkelton}
            dataSource={jobcodesData}
            pagination={{
              onChange(current) {
                setPage(current);
              }
            }}
            scroll = {{x:true}}
            onChange={onChange}
            bordered />
        {/* </TabPane>
      </Tabs> */}
        </Card>
       
       
  );
}

export default ReprocessingRepackingGrid;
